import React from 'react';
import styles from './Radio.module.css';

function RadioGroup({ name, items, value, onChange, fontColor }) {
  return (
    <div className={styles.radioGroup}>
      {items.map((item) => (
        <div key={item.value} className={styles.radioOption}>
          <p className={styles.radioItemWrapper}>
            <input
              type="radio"
              id={name + item.value}
              name={name}
              value={item.value}
              checked={value === item.value}
              onChange={(e) => onChange(e.target.value)}
            />
            <label htmlFor={name + item.value} className={fontColor === 'light' ? styles.lightFont : styles.darkFont}>
              {item.label}
            </label>
          </p>
        </div>
      ))}
    </div>
  );
}

export default RadioGroup;
